import axiosClient from '../util/request';
import { CountryBirth } from '../../interfaces/CountryBirth';
import { DegreeEducation } from '../../interfaces/DegreeEducation';
import { SkinColor } from '../../interfaces/SkinColor';
import { State } from '../../interfaces/State';
import { City } from '../../interfaces/City';
import { RelationshipType } from '../../interfaces/RelationshipType';
import { Bank } from '../../interfaces/Bank';
import { ProfessionalOrganization } from '../../interfaces/ProfessionalOrganization';
import { Nationality } from '../../interfaces/Nationality';
import { ForeignerEntryCondition } from '../../interfaces/ForeignerEntryCondition';


const personalDataRepo = {
  findAllDegreeEducation: () => axiosClient.get<DegreeEducation[]>('/v1/education-level'),
  findAllCountries: () => axiosClient.get<CountryBirth[]>('/v1/countries'),
  findAllSkinColor: () => axiosClient.get<SkinColor[]>('/v1/ethnicity'),
  findAllStates: () => axiosClient.get<State[]>('/v1/states'),
  findAllRelationshipType: () => axiosClient.get<RelationshipType[]>('/v1/dependent-relatives'),
  findAllProfessionalOrganization: () => axiosClient.get<ProfessionalOrganization[]>('/v1/organization-number'),
  findAllBanks: () => axiosClient.get<Bank[]>('/v1/banking'),
  findAllNationalities: () => axiosClient.get<Nationality[]>('/v1/nationality'),
  findAllForeignerEntryConditions: () => axiosClient.get<ForeignerEntryCondition[]>('/v1/admission-conditions'),
  findAllCities: async (state: string) => {
    const url = `/v1/${state}/cities`;
    const response = await axiosClient.get<City[]>(url);
    return response.data;
  },
  findAllDriverLicenseCategories: async () => {
    const response = await axiosClient.get<never[]>('v1/license-categories');
    return response.data.map((licenseCategory => {
      return {id: licenseCategory, description: licenseCategory};
    }));
  },

};

export default personalDataRepo;
